import {Injectable} from "@angular/core";

import { ISvgIcon } from "common/ui/components/svg.icons/interfaces/svg.icon";

// notice this service is part of the SVG module and not the patient picture module
@Injectable({providedIn: "root"})
export class PatientPictureSvgService {

	public patientPictureIcons:ISvgIcon[]= [
		{
			key: null,
			name: 'adult_male',
			active: false,
			graphics: `<xml viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;"><path id="Man-2" class="patient-picture-color" d="M14.9,17.5c-0.2-0.7-0.3-1.5-0.2-2.2c0.6-0.8,0.9-1.7,0.9-2.6c0.5,0.1,0.9-0.8,0.9-1.3c0-0.5,0.1-1.6-0.5-1.5
		c0.1-0.8,0.2-1.6,0.2-2.4c-0.1-1.7-0.5-3.4-4.1-3.4c-0.7-0.1-1.3,0.1-1.8,0.6c0,0-2.3-0.4-2.3,2.8c0,0.8,0.1,1.6,0.2,2.4
		c-0.6-0.1-0.6,1-0.5,1.5c0,0.5,0.4,1.5,0.9,1.3c0,0.9,0.3,1.9,0.9,2.6c0,0,0.1,1.8-0.2,2.2c-0.8,1-4.4,1-6.1,2.1L9,23.3h5.9
		l6.1-3.7C19.3,18.6,15.7,18.7,14.9,17.5z"/>
	<path id="Ellipse_65" class="patient-picture-color" d="M12,1C5.9,1,1,5.9,1,12c0,2.9,1.2,5.7,3.2,7.8C8.5,24,15.5,24,19.8,19.7c4.2-4.3,4.2-11.2,0-15.5
		C17.7,2.2,14.9,1,12,1 M12,0c6.6,0,12,5.4,12,12s-5.4,12-12,12S0,18.6,0,12S5.4,0,12,0z"/>
			</xml>`,
			system: true,
			modified: false,
			deleted: false,
		},
		{
			key: null,
			name: 'adult_female',
			active: false,
			graphics: `<xml viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;"><path class="patient-picture-color" d="M12,0C5.4,0,0,5.4,0,12s5.4,12,12,12s12-5.4,12-12S18.6,0,12,0z M20.2,19.2c-0.8-2-5.3-2.3-6.1-3.2
	c-0.2-0.2-0.3-0.5-0.3-0.8c0.6,0.3,1.2,0.4,1.8,0.2c0.6-0.2,1-0.7,1.2-1.3c0,0-0.9-0.1-1-0.8c-0.1-1.3,1.2-1.4,1.2-4.5
	c0-0.1,0-0.3,0-0.4c0-2.2-1.8-3.9-4-3.9c-0.8-0.1-1.6,0.2-2.2,0.7c0,0-3.7-0.4-3.7,3.7c0,3.4,1.3,3.2,1.2,4.5
	c-0.1,0.8-1.2,0.8-1.2,0.8c0.2,0.6,0.6,1.1,1.2,1.3c0.6,0.2,1.3,0.2,1.8-0.2c0,0.3-0.1,0.6-0.3,0.8c-0.8,0.9-5.4,1.3-6.1,3.3
	C2,17.2,1,14.7,1,12C1,5.9,5.9,1,12,1c2.9,0,5.7,1.2,7.8,3.2C23.8,8.3,24,14.9,20.2,19.2z"/>
			</xml>`,
			system: true,
			modified: false,
			deleted: false,
		},
		{
			key: null,
			name: 'child_male',
			active: false,
			graphics: `<xml viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;"><path class="patient-picture-color" d="M24,12c0-6.6-5.4-12-12-12S0,5.4,0,12c0,3.8,1.7,7.1,4.5,9.3c0.1,0.1,0.2,0.2,0.3,0.3c2,1.5,4.5,2.4,7.2,2.4
	c2.7,0,5.2-0.9,7.2-2.4c0.2-0.1,0.3-0.2,0.4-0.3C22.3,19.1,24,15.8,24,12z M1,12C1,5.9,5.9,1,12,1c2.9,0,5.7,1.2,7.8,3.2
	C23.9,8.4,24,15.2,20,19.5c-0.3-1.9-4.9-2-5.9-3.5c-0.2-0.6-0.2-1.3-0.2-1.9c0.9-0.5,1.5-1.4,1.6-2.4c0.5,0.1,0.8-0.6,0.9-1
	c0-0.4,0.1-1.5-0.5-1.4C15.9,8.3,16,7.5,16,7.5s0.6-0.4,0.3-1.9c-0.1-0.5-0.4-0.9-0.7-1.2c-0.5,0.2-1,0.3-1.6,0.2
	C13.4,4.2,12.7,4,12,4c-0.9,0-1.7,0.4-2.3,1C8.6,5.3,7.9,6.3,8,7.5c0,0.4,0,0.7,0.2,1.7c-0.6-0.1-0.5,1-0.5,1.4c0,0.4,0.4,1.2,0.9,1
	c0.1,1,0.7,1.9,1.6,2.4c0,0.6,0,1.3-0.2,1.9c-0.7,1.4-5.7,1.5-5.9,3.6C2.1,17.5,1,14.8,1,12z"/>
			</xml>`,
			system: true,
			modified: false,
			deleted: false,
		},
		{
			key: null,
			name: 'child_female',
			active: false,
			graphics: `<xml viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;"><path class="patient-picture-color" d="M24,12c0-6.6-5.4-12-12-12S0,5.4,0,12c0,3.8,1.7,7.1,4.5,9.3c0.1,0.1,0.2,0.2,0.4,0.3c2,1.5,4.5,2.4,7.2,2.4
	c2.7,0,5.2-0.9,7.2-2.4c0.1-0.1,0.2-0.1,0.3-0.2C22.2,19.2,24,15.8,24,12z M1,12C1,5.9,5.9,1,12,1c2.9,0,5.7,1.2,7.8,3.2
	c4.2,4.3,4.2,11.2,0,15.5c0,0-0.1,0.1-0.1,0.1c0,0,0,0,0,0v-0.1c0-2.1-4.7-2.2-5.8-3.7c-0.3-0.4-0.2-1.8-0.2-1.8s1.1-0.4,1.7-2.5
	c0.5,0.1,0.6-0.6,0.7-1c0-0.2,0-0.6,0-0.8c0.1,0.2,0.3,0.4,0.3,0.7c0.4,1.3-0.5,1.9-0.3,2.8c0.6,2.7,3.3,1.3,3.3,1.3
	c-0.7,0-1.3-0.6-1.3-1.3c0-1.1,1.5-1.7,1.5-3.7c0-1.4-1.1-2.5-2.5-2.5c-0.4,0-0.8,0-1.2,0.2c-0.3-2-2.2-2.4-3.5-2.3
	c-1,0.1-1.3,0.5-1.3,0.5c-0.2-0.1-0.4-0.1-0.6-0.1C9.3,5.3,8.3,6.2,8.2,7.4C7.8,7.2,7.4,7.2,7,7.2c-0.1,0-0.3,0-0.4,0
	c-1.3,0.1-2.2,1.2-2,2.5c0,2,1.4,2.6,1.3,3.7c0,0.7-0.5,1.3-1.2,1.3c0,0,2.6,1.3,3.2-1.3c0.2-0.9-0.7-1.5-0.3-2.8
	c0.1-0.2,0.2-0.5,0.3-0.7c0,0.2,0,0.6,0,0.8c0,0.4,0.2,1.1,0.7,1c0.7,2.2,1.7,2.5,1.7,2.5s0.1,1.5-0.2,1.8c-1.1,1.4-5.6,1.6-5.7,3.7
	c0,0,0,0.1,0,0.1c0,0,0,0.1-0.1,0.1c0,0,0,0-0.1-0.1C2.2,17.7,1,14.9,1,12z"/>
			</xml>`,
			system: true,
			modified: false,
			deleted: false,
		},
		{
			key: null,
			name: 'baby_male',
			active: false,
			graphics: `<xml viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;"><path class="patient-picture-color" d="M12,0C5.4,0,0,5.4,0,12s5.4,12,12,12s12-5.4,12-12S18.6,0,12,0z M19.8,19.7c-0.3,0.3-0.5,0.5-0.8,0.7c0-0.3-0.2-0.6-0.4-0.8
	c-0.9-1.3-3.5-1.4-4.5-2.7c-0.3-0.4,0-1.5,0-1.5c1.1-0.4,1.9-1.4,2-2.6C16.6,13,17,12,17,11.5c0-0.5,0.1-1.6-0.6-1.5
	c0.3-2-1-3.8-3-4.3c0.3-2.2-2.6-2.4-2.6-2.4s1.1,1.2,0.4,2.2c-0.1,0-0.3,0-0.4,0C8.7,5.9,7.2,7.9,7.5,10C6.9,9.9,7,11.1,7,11.5
	C7,12,7.4,13,7.9,12.8c0.2,1.2,0.9,2.2,2,2.6c0,0,0.3,1.1,0,1.5c-1.2,1.3-3.7,1.4-4.5,2.7C5.2,19.9,5,20.2,5,20.5
	c-0.3-0.2-0.5-0.5-0.8-0.7C2.2,17.7,1,14.9,1,12C1,5.9,5.9,1,12,1c2.9,0,5.7,1.2,7.8,3.2C24,8.5,24,15.4,19.8,19.7z"/>
			</xml>`,
			system: true,
			modified: false,
			deleted: false,
		},
		{
			key: null,
			name: 'baby_female',
			active: false,
			graphics: `<xml viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;"><path class="patient-picture-color" d="M12,0C5.4,0,0,5.4,0,12s5.4,12,12,12s12-5.4,12-12S18.6,0,12,0z M19.8,19.7c-0.3,0.3-0.5,0.5-0.8,0.7
	c-0.1-1-1.8-1.8-4.1-2.2c-0.3-0.2-0.6-0.4-0.8-0.7c-0.2-0.5-0.3-1-0.2-1.5c1.1-0.4,2-1.4,2.2-2.6c0.5,0.1,0.9-0.6,0.9-1.3
	c0-0.5,0.1-1.6-0.6-1.5c0.2-1.5-0.6-2.9-1.9-3.7c0.2,0,0.2-0.2,0.2-0.3l0-1.3c0,0,0-0.1,0-0.1c0-0.3-0.3-0.5-0.6-0.4
	c-0.5,0.1-0.9,0.3-1.3,0.6c0.5-1.7-1.7-2.4-1.7-2.4s0.9,1.7-0.2,2.4c-0.4-0.3-0.8-0.4-1.3-0.6c0,0-0.1,0-0.1,0
	C9.4,4.8,9.2,5,9.2,5.3v1.3c0,0.1,0,0.3,0.2,0.4c-1.3,0.8-2,2.2-1.8,3.7c-0.6-0.1-0.6,1-0.6,1.5c0,0.5,0.4,1.4,0.9,1.3
	c0.2,1.2,1.1,2.2,2.2,2.6c0,0,0.2,1.1-0.2,1.5c-0.3,0.3-0.5,0.5-0.9,0.7C6.7,18.6,5,19.5,5,20.5c-0.3-0.2-0.5-0.4-0.8-0.7
	C2.2,17.7,1,14.9,1,12C1,5.9,5.9,1,12,1c2.9,0,5.7,1.2,7.8,3.2C24,8.5,24,15.4,19.8,19.7z"/>
			</xml>`,
			system: true,
			modified: false,
			deleted: false,
		},
		{
			key: null,
			name: 'adult_unknown',
			active: false,
			graphics: `<xml viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;"><path id="Union_2" class="patient-picture-color" d="M3.5,20.5C1.3,18.2,0,15.2,0,12c0-3.2,1.3-6.2,3.5-8.5C5.8,1.3,8.8,0,12,0c3.2,0,6.2,1.3,8.5,3.5
	C22.7,5.8,24,8.8,24,12c0,1.1-0.1,2.1-0.4,3.1c-0.3-0.3-0.5-0.6-0.8-0.8c0.2-0.8,0.2-1.5,0.2-2.3c0-2.9-1.2-5.7-3.2-7.8
	C17.7,2.2,14.9,1,12,1C9.1,1,6.3,2.2,4.2,4.2C2.2,6.3,1,9.1,1,12c0,2.7,1,5.2,2.7,7.2c0.8-0.3,1.7-0.5,2.5-0.7
	c1.3-0.3,2.5-0.5,2.9-1.1c0.3-0.4,0.2-2.2,0.2-2.2c-0.6-0.8-0.9-1.7-0.9-2.6c0,0-0.1,0-0.1,0c-0.4,0-0.8-0.9-0.8-1.3
	c-0.1-0.5,0-1,0.2-1.4C7.8,9.9,7.9,9.9,8,9.9c0,0,0.1,0,0.1,0C8,9.1,7.9,8.3,7.9,7.4C7.8,6.6,8.1,5.7,8.7,5.1
	C9.1,4.8,9.5,4.6,10,4.6c0.1,0,0.1,0,0.2,0C10.7,4.2,11.4,4,12,4.1c1.2-0.1,2.5,0.2,3.4,1c0.5,0.7,0.8,1.5,0.7,2.3
	c0,0.8-0.1,1.6-0.2,2.4c0,0,0.1,0,0.1,0c0.1,0,0.2,0,0.2,0.1c0.2,0.4,0.3,0.9,0.2,1.4c0,0.5-0.4,1.3-0.8,1.3c0,0-0.1,0-0.1,0
	c-0.1,0.6-0.2,1.2-0.4,1.7C13.8,15.5,13,17.2,13,19c0,1.4,0.5,2.7,1.3,3.8l0,0c0.1,0.2,0.3,0.3,0.4,0.5l0,0c0.1,0.1,0.2,0.2,0.4,0.3
	c-1,0.3-2.1,0.4-3.1,0.4C8.8,24,5.8,22.7,3.5,20.5z M14,19.1c0-2.8,2.2-5,4.9-5.1c0,0,0,0,0,0c2.8,0,5,2.2,5.1,4.9
	c0,2.8-2.2,5-4.9,5.1c0,0,0,0,0,0H19C16.3,24,14,21.8,14,19.1z M18.2,21.3c0,0.4,0.3,0.7,0.7,0.7c0,0,0,0,0,0h0
	c0.4,0,0.7-0.3,0.7-0.7c0,0,0,0,0,0c0-0.4-0.3-0.7-0.7-0.8c0,0,0,0-0.1,0h0C18.5,20.6,18.2,20.9,18.2,21.3
	C18.2,21.3,18.2,21.3,18.2,21.3L18.2,21.3z M19.6,17.2c0.1,0.1,0.2,0.3,0.2,0.5c0,0.2-0.1,0.3-0.2,0.4c-0.1,0.1-0.1,0.2-0.2,0.2
	c-0.3,0.2-0.6,0.4-0.9,0.7c-0.2,0.2-0.2,0.5-0.2,0.8V20h1.2v0c0-0.1,0-0.2,0-0.3c0.1-0.2,0.2-0.3,0.3-0.4l0.3-0.2
	c0.2-0.2,0.4-0.3,0.6-0.5c0.2-0.2,0.3-0.6,0.3-0.9c0-0.5-0.2-1-0.6-1.3C20,16.1,19.5,15.9,19,16c-0.4,0-0.8,0.1-1.1,0.3
	c-0.5,0.4-0.8,1-0.8,1.6v0.1h1.2v0c0-0.2,0.1-0.4,0.2-0.6c0.1-0.2,0.4-0.3,0.6-0.3C19.2,17,19.4,17,19.6,17.2L19.6,17.2z"/>
			</xml>`,
			system: true,
			modified: false,
			deleted: false,
		},
		{
			key: null,
			name: 'child_unknown',
			active: false,
			graphics: `<xml viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;"><path id="Unknown_Child-2" class="patient-picture-color" d="M4.6,21.5c0,0-0.1-0.1-0.1-0.1c-0.3-0.3-0.7-0.6-1-0.9C1.3,18.2,0,15.2,0,12c0-3.2,1.3-6.2,3.5-8.5
	C5.8,1.3,8.8,0,12,0c3.2,0,6.2,1.3,8.5,3.5C22.7,5.8,24,8.8,24,12c0,1.1-0.1,2.1-0.4,3.1c-0.3-0.3-0.5-0.6-0.8-0.8
	c0.2-0.8,0.2-1.5,0.2-2.3c0-2.9-1.2-5.7-3.2-7.8C17.7,2.2,14.9,1,12,1C9.1,1,6.3,2.2,4.2,4.2C2.2,6.3,1,9.1,1,12
	c0,2.8,1.1,5.5,3,7.6c0.1-1.2,1.7-1.7,3.3-2.2C8.5,17,9.6,16.6,9.9,16c0.2-0.6,0.2-1.3,0.2-1.9c-0.9-0.5-1.5-1.4-1.6-2.4
	c0,0-0.1,0-0.1,0c-0.4,0-0.7-0.6-0.8-1.1c-0.1-0.4,0-0.9,0.2-1.3C7.9,9.2,8,9.2,8.1,9.2c0,0,0.1,0,0.1,0C8,8.3,8,8,8,7.6l0-0.1
	C7.9,6.4,8.6,5.3,9.7,5c0.6-0.6,1.4-1,2.3-1c0.5,0,1.1,0.1,1.6,0.3c0.2,0.1,0.3,0.1,0.5,0.2c0.2,0,0.3,0.1,0.5,0.1
	c0.4,0,0.7-0.1,1.1-0.2c0.3,0.3,0.6,0.8,0.7,1.2C16.6,7.1,16,7.5,16,7.5s0,0,0,0.1c0,0.3-0.1,0.9-0.2,1.6c0,0,0.1,0,0.1,0
	c0.1,0,0.2,0,0.2,0.1c0.2,0.4,0.3,0.9,0.2,1.3c0,0.4-0.3,1.1-0.8,1.1c0,0-0.1,0-0.1,0c-0.1,1-0.7,1.9-1.6,2.4c0,0.5,0,1.1,0.1,1.6
	c-0.5,0.7-0.8,1.5-0.9,2.3l0,0C13,18.3,13,18.7,13,19c0,1.4,0.5,2.7,1.3,3.8l0,0c0.2,0.3,0.5,0.6,0.8,0.8c-1,0.3-2.1,0.4-3.1,0.4
	C9.3,24,6.7,23.1,4.6,21.5z M12,23L12,23z M14,19.1c0-2.8,2.2-5,4.9-5.1c0,0,0,0,0,0c2.8,0,5,2.2,5.1,4.9c0,2.8-2.2,5-4.9,5.1
	c0,0,0,0,0,0H19C16.3,24,14,21.8,14,19.1z M18.2,21.3c0,0.4,0.3,0.7,0.7,0.7c0,0,0,0,0,0h0c0.4,0,0.7-0.3,0.7-0.7c0,0,0,0,0,0
	c0-0.4-0.3-0.7-0.7-0.8c0,0,0,0-0.1,0h0C18.5,20.6,18.2,20.9,18.2,21.3C18.2,21.3,18.2,21.3,18.2,21.3L18.2,21.3z M19.6,17.2
	c0.1,0.1,0.2,0.3,0.2,0.5c0,0.2-0.1,0.3-0.2,0.4c-0.1,0.1-0.1,0.2-0.2,0.2c-0.3,0.2-0.6,0.4-0.9,0.7c-0.2,0.2-0.2,0.5-0.2,0.8V20
	h1.2v0c0-0.1,0-0.2,0-0.3c0.1-0.2,0.2-0.3,0.3-0.4l0.3-0.2c0.2-0.2,0.4-0.3,0.6-0.5c0.2-0.2,0.3-0.6,0.3-0.9c0-0.5-0.2-1-0.6-1.3
	C20,16.1,19.5,15.9,19,16c-0.4,0-0.8,0.1-1.1,0.3c-0.5,0.4-0.8,1-0.8,1.6v0.1h1.2v0c0-0.2,0.1-0.4,0.2-0.6c0.1-0.2,0.4-0.3,0.6-0.3
	C19.2,17,19.4,17,19.6,17.2L19.6,17.2z"/>
			</xml>`,
			system: true,
			modified: false,
			deleted: false,
		},
		{
			key: null,
			name: 'baby_unknown',
			active: false,
			graphics: `<xml viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;"><path id="Unknown_Baby-2" class="patient-picture-color" d="M3.5,20.5C1.3,18.2,0,15.2,0,12c0-3.2,1.3-6.2,3.5-8.5C5.8,1.3,8.8,0,12,0c3.2,0,6.2,1.3,8.5,3.5
	C22.7,5.8,24,8.8,24,12c0,1.1-0.1,2.1-0.4,3.1c-0.3-0.3-0.5-0.6-0.8-0.8c0.2-0.8,0.2-1.5,0.2-2.3c0-2.9-1.2-5.7-3.2-7.8
	C17.7,2.2,14.9,1,12,1C9.1,1,6.3,2.2,4.2,4.2C2.2,6.3,1,9.1,1,12c0,2.9,1.2,5.7,3.2,7.8C4.5,20,4.7,20.3,5,20.5
	c0-0.3,0.2-0.6,0.4-0.8C6,19,6.8,18.5,7.6,18.3c0.9-0.3,1.7-0.7,2.3-1.3c0.3-0.4,0-1.5,0-1.5c-1.1-0.4-1.9-1.4-2-2.6
	c0,0-0.1,0-0.1,0C7.4,12.8,7,12,7,11.5c-0.1-0.5,0-1,0.2-1.4C7.3,10.1,7.4,10,7.5,10c0,0,0.1,0,0.1,0C7.4,9,7.7,7.9,8.4,7
	c0.7-0.9,1.8-1.4,2.9-1.4c0.8-1-0.4-2.2-0.4-2.2l0,0h0c0.8,0.1,1.6,0.4,2.2,1c0.3,0.4,0.5,0.9,0.4,1.4c1.2,0.2,2.1,1,2.6,2.1
	c0.3,0.7,0.4,1.5,0.4,2.2c0,0,0.1,0,0.1,0c0.1,0,0.2,0,0.2,0.1c0.2,0.4,0.3,0.9,0.2,1.4c0,0.5-0.4,1.3-0.8,1.3c0,0-0.1,0-0.1,0
	c-0.1,0.4-0.2,0.8-0.4,1.1c-0.6,0.4-1.1,0.8-1.5,1.4c-0.1,0.1-0.2,0.1-0.2,0.1s0,0.1-0.1,0.3c-0.6,1-1,2.1-1,3.3c0,0.2,0,0.5,0,0.7
	c0.1,1.1,0.6,2.2,1.3,3l0,0c0.2,0.3,0.5,0.6,0.8,0.8c-1,0.3-2.1,0.4-3.1,0.4C8.8,24,5.8,22.7,3.5,20.5z M12,23L12,23z M14,19.1
	c0-2.8,2.2-5,4.9-5.1c0,0,0,0,0,0c2.8,0,5,2.2,5.1,4.9c0,2.8-2.2,5-4.9,5.1c0,0,0,0,0,0H19C16.3,24,14,21.8,14,19.1z M18.2,21.3
	c0,0.4,0.3,0.7,0.7,0.7c0,0,0,0,0,0h0c0.4,0,0.7-0.3,0.7-0.7c0,0,0,0,0,0c0-0.4-0.3-0.7-0.7-0.8c0,0,0,0-0.1,0h0
	C18.5,20.6,18.2,20.9,18.2,21.3C18.2,21.3,18.2,21.3,18.2,21.3L18.2,21.3z M19.6,17.2c0.1,0.1,0.2,0.3,0.2,0.5
	c0,0.2-0.1,0.3-0.2,0.4c-0.1,0.1-0.1,0.2-0.2,0.2c-0.3,0.2-0.6,0.4-0.9,0.7c-0.2,0.2-0.2,0.5-0.2,0.8V20h1.2v0c0-0.1,0-0.2,0-0.3
	c0.1-0.2,0.2-0.3,0.3-0.4l0.3-0.2c0.2-0.2,0.4-0.3,0.6-0.5c0.2-0.2,0.3-0.6,0.3-0.9c0-0.5-0.2-1-0.6-1.3C20,16.1,19.5,15.9,19,16
	c-0.4,0-0.8,0.1-1.1,0.3c-0.5,0.4-0.8,1-0.8,1.6v0.1h1.2v0c0-0.2,0.1-0.4,0.2-0.6c0.1-0.2,0.4-0.3,0.6-0.3
	C19.2,17,19.4,17,19.6,17.2L19.6,17.2z"/>
			</xml>`,
			system: true,
			modified: false,
			deleted: false,
		},
		{
			key: null,
			name: 'adult_male_deceased',
			active: false,
			graphics: `<xml viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;">
	<path id="Union_4"  class="grayed-background patient-picture-color" d="M0,12C0,5.4,5.4,0,12,0s12,5.4,12,12s-5.4,12-12,12S0,18.6,0,12z M14.7,15.3
		c-0.1,0.8,0,1.5,0.2,2.2c0.8,1,3.6,1.1,5.4,1.7c1.8-2,2.7-4.6,2.7-7.3c0-2.9-1.2-5.7-3.2-7.8C17.7,2.2,14.9,1,12,1
		C9.1,1,6.3,2.2,4.2,4.2C2.2,6.3,1,9.1,1,12c0,2.7,1,5.2,2.7,7.2c1.8-0.7,4.7-0.9,5.4-1.7c0.3-0.4,0.2-2.2,0.2-2.2
		c-0.6-0.8-0.9-1.7-0.9-2.6c-0.5,0.1-0.9-0.8-0.9-1.3c0-0.5-0.1-1.6,0.5-1.5C7.9,9.1,7.9,8.3,7.9,7.4c0-3.2,2.3-2.8,2.3-2.8
		C10.7,4.2,11.3,4,12,4.1c3.6,0,4.1,1.7,4.1,3.4c0,0.8-0.1,1.6-0.2,2.4c0.6-0.1,0.6,1,0.5,1.5c0,0.5-0.4,1.5-0.9,1.3
		C15.5,13.6,15.2,14.5,14.7,15.3z"/>
	<path id="Ellipse_65" class="patient-picture-color" d="M12,1C5.9,1,1,5.9,1,12c0,2.9,1.2,5.7,3.2,7.8C8.5,24,15.5,24,19.8,19.7c4.2-4.3,4.2-11.2,0-15.5
		C17.7,2.2,14.9,1,12,1 M12,0c6.6,0,12,5.4,12,12s-5.4,12-12,12S0,18.6,0,12S5.4,0,12,0z"/>
			</xml>`,
			system: true,
			modified: false,
			deleted: false,
		},
		{
			key: null,
			name: 'adult_female_deceased',
			active: false,
			graphics: `<xml viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;"><path id="Woman" class="grayed-background patient-picture-color" d="M4,20c0-0.1,0-0.2,0-0.2H3.6c0-2.5,5.3-2.8,6.2-3.8c0.2-0.2,0.3-0.5,0.3-0.8
		c-0.6,0.3-1.2,0.4-1.8,0.2c-0.6-0.2-1-0.7-1.2-1.3c0,0,1.1-0.1,1.2-0.8c0.1-1.3-1.2-1.1-1.2-4.5c0-4.1,3.7-3.7,3.7-3.7
		c0.6-0.5,1.4-0.7,2.2-0.7c2.2,0,4,1.7,4,3.9c0,0.1,0,0.3,0,0.4c0,3.1-1.3,3.2-1.2,4.5c0.1,0.8,1,0.8,1,0.8
		c-0.2,0.6-0.6,1.1-1.2,1.3c-0.6,0.2-1.3,0.1-1.8-0.2c0,0.3,0.1,0.6,0.3,0.8c0.8,1,6.2,1.4,6.2,3.8H20c0,0.1,0,0.2,0,0.2
		c0,1.7-3.6,3-8,3S4,21.7,4,20z"/>
	<path id="Ellipse_65" class="patient-picture-color" d="M12,1C5.9,1,1,5.9,1,12c0,2.9,1.2,5.7,3.2,7.8C8.5,24,15.5,24,19.8,19.7c4.2-4.3,4.2-11.2,0-15.5
		C17.7,2.2,14.9,1,12,1 M12,0c6.6,0,12,5.4,12,12s-5.4,12-12,12S0,18.6,0,12S5.4,0,12,0z"/>
			</xml>`,
			system: true,
			modified: false,
			deleted: false,
		},
		{
			key: null,
			name: 'adult_unknown_deceased',
			active: false,
			graphics: `<xml viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;"><path id="Union_76" class="patient-picture-color" d="M14,19.1c0-2.8,2.2-5,4.9-5.1c2.8,0,5,2.2,5.1,4.9c0,0,0,0,0,0c0,2.8-2.2,5-4.9,5.1c0,0,0,0,0,0H19
		C16.3,24,14,21.8,14,19.1z M18.2,21.3c0,0.4,0.3,0.7,0.7,0.7c0,0,0,0,0,0h0c0.4,0,0.7-0.3,0.7-0.7c0,0,0,0,0,0
		c0-0.4-0.3-0.7-0.7-0.8c0,0,0,0-0.1,0h0C18.5,20.6,18.2,20.9,18.2,21.3C18.2,21.3,18.2,21.3,18.2,21.3L18.2,21.3z M19.6,17.2
		c0.1,0.1,0.2,0.3,0.2,0.5c0,0.2-0.1,0.3-0.2,0.4c-0.1,0.1-0.1,0.2-0.2,0.2c-0.3,0.2-0.6,0.4-0.9,0.7c-0.2,0.2-0.2,0.5-0.2,0.8V20
		h1.2v0c0-0.1,0-0.2,0-0.3c0.1-0.2,0.2-0.3,0.3-0.4l0.3-0.2c0.2-0.2,0.4-0.3,0.6-0.5c0.2-0.2,0.3-0.6,0.3-0.9c0-0.5-0.2-1-0.6-1.3
		C20,16.1,19.5,15.9,19,16c-0.4,0-0.8,0.1-1.1,0.3c-0.5,0.4-0.8,1-0.8,1.6v0.1h1.2v0c0-0.2,0.1-0.4,0.2-0.6c0.1-0.2,0.4-0.3,0.6-0.3
		C19.2,17,19.4,17,19.6,17.2L19.6,17.2z M3.5,20.5C1.3,18.2,0,15.2,0,12c0-3.2,1.3-6.2,3.5-8.5C5.8,1.3,8.8,0,12,0
		c3.2,0,6.2,1.3,8.5,3.5C22.7,5.8,24,8.8,24,12c0,1.1-0.1,2.1-0.4,3.1c-0.3-0.3-0.5-0.6-0.8-0.8c0.2-0.8,0.2-1.5,0.2-2.3
		c0-2.9-1.2-5.7-3.2-7.8C17.7,2.2,14.9,1,12,1C9.1,1,6.3,2.2,4.2,4.2C2.2,6.3,1,9.1,1,12c0,2.9,1.2,5.7,3.2,7.8
		C6.3,21.8,9.1,23,12,23c0.8,0,1.6-0.1,2.3-0.2c0.2,0.3,0.5,0.6,0.8,0.8c-1,0.3-2.1,0.4-3.1,0.4C8.8,24,5.8,22.7,3.5,20.5L3.5,20.5z
		"/>
	<path id="Subtraction_8" class="grayed-background patient-picture-color" d="M14.8,23.3H9L3,19.6c1-0.5,2.1-0.8,3.2-1c1.3-0.3,2.5-0.5,2.9-1.1c0.3-0.4,0.2-2.2,0.2-2.2
		c-0.6-0.8-0.9-1.7-0.9-2.6c0,0-0.1,0-0.1,0c-0.4,0-0.8-0.9-0.8-1.3c-0.1-0.5,0-1,0.2-1.4C7.8,9.9,7.9,9.9,8,9.9c0,0,0.1,0,0.1,0
		C7.9,9.1,7.9,8.3,7.9,7.4C7.8,6.6,8.1,5.7,8.7,5.1C9.1,4.8,9.5,4.6,10,4.6c0.1,0,0.1,0,0.2,0C10.7,4.2,11.3,4,12,4.1
		c1.2-0.1,2.5,0.2,3.4,1c0.5,0.7,0.8,1.5,0.7,2.3c0,0.8-0.1,1.6-0.2,2.4c0,0,0.1,0,0.1,0c0.1,0,0.2,0,0.2,0.1
		c0.2,0.4,0.3,0.9,0.2,1.4c0,0.5-0.4,1.3-0.8,1.3c0,0-0.1,0-0.1,0c-0.1,0.6-0.2,1.2-0.4,1.7C13.8,15.5,13,17.2,13,19
		C13,20.6,13.6,22.2,14.8,23.3L14.8,23.3z"/>
			</xml>`,
			system: true,
			modified: false,
			deleted: false,
		},
		{
			key: null,
			name: 'child_male_deceased',
			active: false,
			graphics: `<xml viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;"><path id="Boy" class="grayed-background patient-picture-color" d="M4,20.5c0-0.2,0.1-0.4,0.2-0.5H4v-0.3c0-2.2,5.2-2.2,5.9-3.7c0.2-0.6,0.2-1.3,0.2-1.9
		c-0.9-0.5-1.5-1.4-1.6-2.4c-0.5,0.1-0.8-0.6-0.9-1c0-0.4-0.1-1.5,0.5-1.4C8,8.2,8,7.9,8,7.5C7.9,6.3,8.6,5.3,9.7,5
		c0.6-0.6,1.4-1,2.3-1c0.7,0,1.4,0.2,2.1,0.5c0.5,0.1,1.1,0.1,1.6-0.2c0.3,0.3,0.6,0.8,0.7,1.2C16.7,7.1,16,7.5,16,7.5
		s-0.1,0.8-0.2,1.7c0.6-0.1,0.5,1,0.5,1.4c0,0.4-0.4,1.2-0.9,1c-0.1,1-0.7,1.9-1.6,2.4c-0.1,0.6,0,1.3,0.2,1.9
		c1,1.5,5.9,1.5,5.9,3.7c0,0.1,0,0.3,0,0.3h-0.2c0.1,0.1,0.2,0.3,0.2,0.5c0,1.4-3.6,2.5-8,2.5S4,21.9,4,20.5z"/>
	<path id="Ellipse_65" class="patient-picture-color" d="M12,1C5.9,1,1,5.9,1,12c0,2.9,1.2,5.7,3.2,7.8C8.5,24,15.5,24,19.8,19.7c4.2-4.3,4.2-11.2,0-15.5
		C17.7,2.2,14.9,1,12,1 M12,0c6.6,0,12,5.4,12,12s-5.4,12-12,12S0,18.6,0,12S5.4,0,12,0z"/>
			</xml>`,
			system: true,
			modified: false,
			deleted: false,
		},
		{
			key: null,
			name: 'child_female_deceased',
			active: false,
			graphics: `<xml viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;"><path id="Girl" class="grayed-background patient-picture-color" d="M4,20.5c0-0.3,0.1-0.5,0.4-0.7c0,0,0-0.1,0-0.1c0-2.1,4.6-2.3,5.7-3.7c0.3-0.4,0.2-1.8,0.2-1.8
		s-1-0.3-1.7-2.5c-0.5,0.1-0.6-0.6-0.7-1c0-0.2,0-0.6,0-0.8c-0.1,0.2-0.3,0.4-0.3,0.7c-0.4,1.3,0.5,1.9,0.3,2.8
		c-0.6,2.7-3.2,1.3-3.2,1.3c0.7-0.1,1.2-0.6,1.2-1.3c0-1.1-1.3-1.7-1.3-3.7c-0.1-1.3,0.8-2.4,2-2.5c0.1,0,0.3,0,0.4,0
		c0.4,0,0.8,0.1,1.2,0.2c0.1-1.2,1.1-2,2.2-1.9c0.2,0,0.4,0.1,0.6,0.1c0,0,0.3-0.4,1.3-0.5c1.3-0.1,3.2,0.3,3.5,2.3
		c0.4-0.1,0.8-0.2,1.2-0.2c1.4,0,2.5,1.1,2.5,2.5c0,2-1.5,2.6-1.5,3.7c0,0.7,0.6,1.3,1.3,1.3c0,0-2.8,1.3-3.3-1.3
		c-0.2-0.9,0.7-1.5,0.3-2.8c-0.1-0.2-0.2-0.5-0.3-0.7c0,0.2,0,0.6,0,0.8c0,0.4-0.2,1.1-0.7,1c-0.6,2.1-1.7,2.5-1.7,2.5
		s-0.1,1.5,0.2,1.8c1.2,1.4,5.8,1.6,5.8,3.7v0.1c0.2,0.2,0.3,0.5,0.4,0.7c0,1.4-3.6,2.5-8,2.5S4,21.9,4,20.5z"/>
	<path id="Ellipse_65" class="patient-picture-color" d="M12,1C5.9,1,1,5.9,1,12c0,2.9,1.2,5.7,3.2,7.8C8.5,24,15.5,24,19.8,19.7c4.2-4.3,4.2-11.2,0-15.5
		C17.7,2.2,14.9,1,12,1 M12,0c6.6,0,12,5.4,12,12s-5.4,12-12,12S0,18.6,0,12S5.4,0,12,0z"/>
			</xml>`,
			system: true,
			modified: false,
			deleted: false,
		},
		{
			key: null,
			name: 'child_unknown_deceased',
			active: false,
			graphics: `<xml viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;"><path id="Union_75" class="patient-picture-color" d="M14,19.1c0-2.8,2.2-5,4.9-5.1c0,0,0,0,0,0c2.8,0,5,2.2,5.1,4.9c0,2.8-2.2,5-4.9,5.1c0,0,0,0,0,0H19
		C16.3,24,14,21.8,14,19.1z M18.2,21.3c0,0.4,0.3,0.7,0.7,0.7c0,0,0,0,0,0h0c0.4,0,0.7-0.3,0.7-0.7c0,0,0,0,0,0
		c0-0.4-0.3-0.7-0.7-0.8c0,0,0,0-0.1,0h0C18.5,20.6,18.2,20.9,18.2,21.3C18.2,21.3,18.2,21.3,18.2,21.3L18.2,21.3z M19.6,17.2
		c0.1,0.1,0.2,0.3,0.2,0.5c0,0.2-0.1,0.3-0.2,0.4c-0.1,0.1-0.1,0.2-0.2,0.2c-0.3,0.2-0.6,0.4-0.9,0.7c-0.2,0.2-0.2,0.5-0.2,0.8V20
		h1.2v0c0-0.1,0-0.2,0-0.3c0.1-0.2,0.2-0.3,0.3-0.4l0.3-0.2c0.2-0.2,0.4-0.3,0.6-0.5c0.2-0.2,0.3-0.6,0.3-0.9c0-0.5-0.2-1-0.6-1.3
		C20,16.1,19.5,15.9,19,16c-0.4,0-0.8,0.1-1.1,0.3c-0.5,0.4-0.8,1-0.8,1.6v0.1h1.2v0c0-0.2,0.1-0.4,0.2-0.6c0.1-0.2,0.4-0.3,0.6-0.3
		C19.2,17,19.4,17,19.6,17.2L19.6,17.2z M3.5,20.5C1.3,18.2,0,15.2,0,12c0-3.2,1.3-6.2,3.5-8.5C5.8,1.3,8.8,0,12,0
		c3.2,0,6.2,1.3,8.5,3.5C22.7,5.8,24,8.8,24,12c0,1.1-0.1,2.1-0.4,3.1c-0.2-0.3-0.5-0.6-0.8-0.8c0.2-0.8,0.2-1.5,0.2-2.3
		c0-2.9-1.2-5.7-3.2-7.8C17.7,2.2,14.9,1,12,1C9.1,1,6.3,2.2,4.2,4.2C2.2,6.3,1,9.1,1,12c0,2.9,1.2,5.7,3.2,7.8
		C6.3,21.8,9.1,23,12,23c0.8,0,1.6-0.1,2.3-0.2c0.2,0.3,0.5,0.6,0.8,0.8c-1,0.3-2.1,0.4-3.1,0.4C8.8,24,5.8,22.7,3.5,20.5L3.5,20.5z
		"/>
	<path id="Union_72" class="grayed-background patient-picture-color" d="M4,20.5c0-0.2,0.1-0.4,0.2-0.5H4v-0.3c0-1.2,1.7-1.8,3.3-2.3C8.5,17,9.6,16.6,9.9,16
		c0.2-0.6,0.2-1.3,0.2-1.9c-0.9-0.5-1.5-1.4-1.6-2.4c0,0-0.1,0-0.1,0c-0.4,0-0.7-0.6-0.8-1.1c-0.1-0.4,0-0.9,0.2-1.3
		C7.9,9.2,8,9.2,8.1,9.2c0,0,0.1,0,0.1,0C8.1,8.3,8,8,8,7.6l0-0.1C7.9,6.4,8.6,5.3,9.7,5c0.6-0.6,1.4-1,2.3-1c0.5,0,1.1,0.1,1.6,0.3
		c0.2,0.1,0.3,0.1,0.5,0.2c0.2,0,0.3,0.1,0.5,0.1c0.4,0,0.7-0.1,1.1-0.2c0.3,0.3,0.6,0.8,0.7,1.2C16.6,7.1,16,7.5,16,7.5s0,0,0,0.1
		c0,0.3-0.1,0.9-0.2,1.6c0,0,0.1,0,0.1,0c0.1,0,0.2,0,0.2,0.1c0.2,0.4,0.3,0.9,0.2,1.3c0,0.4-0.3,1.1-0.8,1.1c0,0-0.1,0-0.1,0
		c-0.1,1-0.7,1.9-1.6,2.4c0,0.5,0,1.1,0.1,1.6c-0.5,0.7-0.8,1.5-0.9,2.3l0,0C13,18.3,13,18.7,13,19c0,1.4,0.5,2.8,1.4,3.9
		C13.6,23,12.8,23,12,23C7.6,23,4,21.9,4,20.5z"/>
			</xml>`,
			system: true,
			modified: false,
			deleted: false,
		},
		{
			key: null,
			name: 'baby_male_deceased',
			active: false,
			graphics: `<xml viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;"><path id="Baby_Boy" class="grayed-background patient-picture-color" d="M5,20.5c0-0.3,0.2-0.6,0.4-0.8c0.8-1.3,3.4-1.4,4.5-2.7c0.3-0.4,0-1.5,0-1.5
		c-1.1-0.4-1.9-1.4-2-2.6C7.4,13,7,12,7,11.5c0-0.5-0.1-1.6,0.6-1.5c-0.3-2.1,1.2-4.1,3.3-4.4c0.1,0,0.3,0,0.4,0
		c0.8-1-0.4-2.2-0.4-2.2s2.9,0.2,2.6,2.4c2,0.4,3.2,2.3,3,4.3c0.6-0.1,0.6,1,0.6,1.5c0,0.5-0.4,1.4-0.9,1.3c-0.2,1.2-0.9,2.2-2,2.6
		c0,0-0.3,1.1,0,1.5c1,1.3,3.6,1.4,4.5,2.7c0.3,0.2,0.4,0.5,0.4,0.9c0,1.4-3.1,2.5-7,2.5S5,21.9,5,20.5z"/>
	<path id="Ellipse_65"  class="patient-picture-color" d="M12,1C5.9,1,1,5.9,1,12c0,2.9,1.2,5.7,3.2,7.8C8.5,24,15.5,24,19.8,19.7c4.2-4.3,4.2-11.2,0-15.5
		C17.7,2.2,14.9,1,12,1 M12,0c6.6,0,12,5.4,12,12s-5.4,12-12,12S0,18.6,0,12S5.4,0,12,0z"/>
			</xml>`,
			system: true,
			modified: false,
			deleted: false,
		},
		{
			key: null,
			name: 'baby_female_deceased',
			active: false,
			graphics: `<xml viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;"><path id="Baby_Girl" class="grayed-background patient-picture-color" d="M5,20.5c0-1,1.7-1.9,4.1-2.3c0.3-0.2,0.6-0.4,0.9-0.7c0.3-0.4,0.2-1.5,0.2-1.5
		c-1.1-0.4-2-1.4-2.2-2.6C7.4,13.6,7,12.7,7,12.2c0-0.5-0.1-1.6,0.6-1.5C7.4,9.2,8.1,7.7,9.4,7C9.2,7,9.2,6.7,9.2,6.6V5.3
		c0-0.3,0.2-0.5,0.4-0.6c0,0,0.1,0,0.1,0c0.5,0.1,0.9,0.3,1.3,0.6c1.1-0.7,0.2-2.4,0.2-2.4s2.2,0.7,1.7,2.4c0.4-0.3,0.8-0.5,1.3-0.6
		c0.3,0,0.5,0.2,0.6,0.4c0,0,0,0.1,0,0.1l0,1.3c0,0.1,0,0.3-0.2,0.3c1.3,0.8,2,2.2,1.9,3.7c0.6-0.1,0.6,1,0.6,1.5
		c0,0.7-0.4,1.4-0.9,1.3c-0.2,1.2-1.1,2.2-2.2,2.6c-0.1,0.5,0,1,0.2,1.5c0.2,0.3,0.5,0.5,0.8,0.7c2.4,0.4,4.1,1.3,4.1,2.3
		c0,1.4-3.1,2.5-7,2.5S5,21.9,5,20.5z"/>
	<path id="Ellipse_65" class="patient-picture-color" d="M12,1C5.9,1,1,5.9,1,12c0,2.9,1.2,5.7,3.2,7.8C8.5,24,15.5,24,19.8,19.7c4.2-4.3,4.2-11.2,0-15.5
		C17.7,2.2,14.9,1,12,1 M12,0c6.6,0,12,5.4,12,12s-5.4,12-12,12S0,18.6,0,12S5.4,0,12,0z"/>
			</xml>`,
			system: true,
			modified: false,
			deleted: false,
		},
		{
			key: null,
			name: 'baby_unknown_deceased',
			active: false,
			graphics: `<xml viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;"><path id="Union_74" class="patient-picture-color" d="M14,19.1c0-2.8,2.2-5,4.9-5.1c0,0,0,0,0,0c2.8,0,5,2.2,5.1,4.9c0,2.8-2.2,5-4.9,5.1c0,0,0,0,0,0H19
		C16.3,24,14,21.8,14,19.1z M18.2,21.3c0,0.4,0.3,0.7,0.7,0.7c0,0,0,0,0,0h0c0.4,0,0.7-0.3,0.7-0.7c0,0,0,0,0,0
		c0-0.4-0.3-0.7-0.7-0.8c0,0,0,0-0.1,0h0C18.5,20.6,18.2,20.9,18.2,21.3C18.2,21.3,18.2,21.3,18.2,21.3L18.2,21.3z M19.6,17.2
		c0.1,0.1,0.2,0.3,0.2,0.5c0,0.2-0.1,0.3-0.2,0.4c-0.1,0.1-0.1,0.2-0.2,0.2c-0.3,0.2-0.6,0.4-0.9,0.7c-0.2,0.2-0.2,0.5-0.2,0.8V20
		h1.2v0c0-0.1,0-0.2,0-0.3c0.1-0.2,0.2-0.3,0.3-0.4l0.3-0.2c0.2-0.2,0.4-0.3,0.6-0.5c0.2-0.2,0.3-0.6,0.3-0.9c0-0.5-0.2-1-0.6-1.3
		C20,16.1,19.5,15.9,19,16c-0.4,0-0.8,0.1-1.1,0.3c-0.5,0.4-0.8,1-0.8,1.6v0.1h1.2v0c0-0.2,0.1-0.4,0.2-0.6c0.1-0.2,0.4-0.3,0.6-0.3
		C19.2,17,19.4,17,19.6,17.2L19.6,17.2z M3.5,20.5C1.3,18.2,0,15.2,0,12c0-3.2,1.3-6.2,3.5-8.5C5.8,1.3,8.8,0,12,0
		c3.2,0,6.2,1.3,8.5,3.5C22.7,5.8,24,8.8,24,12c0,1.1-0.1,2.1-0.4,3.1c-0.3-0.3-0.5-0.6-0.8-0.8c0.2-0.8,0.2-1.5,0.2-2.3
		c0-2.9-1.2-5.7-3.2-7.8C17.7,2.2,14.9,1,12,1C9.1,1,6.3,2.2,4.2,4.2C2.2,6.3,1,9.1,1,12c0,2.9,1.2,5.7,3.2,7.8
		C6.3,21.8,9.1,23,12,23c0.8,0,1.6-0.1,2.3-0.2c0.2,0.3,0.5,0.6,0.8,0.8c-1,0.3-2.1,0.4-3.1,0.4C8.8,24,5.8,22.7,3.5,20.5L3.5,20.5z
		"/>
	<path id="Union_73_00000120525566009081289290000017960466171025336494_" class="grayed-background patient-picture-color" d="M14,15.7c-0.6,0.9-0.9,2-1,3.1v0
		c0,0,0,0,0,0s0,0,0,0s0,0,0,0s0,0,0,0s0,0,0,0c0,0,0,0,0,0.1c0,0,0,0,0,0s0,0,0,0.1v0c0,1.4,0.5,2.7,1.4,3.7
		C13.6,22.9,12.8,23,12,23c-3.9,0-7-1.1-7-2.5c0-0.3,0.2-0.6,0.4-0.8C6,19,6.8,18.5,7.6,18.3c0.9-0.3,1.7-0.7,2.3-1.3
		c0.3-0.4,0-1.5,0-1.5c-1.1-0.4-1.9-1.4-2-2.6c0,0-0.1,0-0.1,0C7.4,12.8,7,12,7,11.5c-0.1-0.5,0-1,0.2-1.4C7.3,10.1,7.4,10,7.5,10
		c0,0,0.1,0,0.1,0C7.4,9,7.7,7.9,8.3,7c0.7-0.9,1.8-1.4,2.9-1.4c0.8-1-0.4-2.2-0.4-2.2l0,0h0c0.8,0.1,1.6,0.4,2.2,1
		c0.3,0.4,0.5,0.9,0.4,1.4c1.2,0.2,2.1,1,2.6,2.1c0.3,0.7,0.4,1.5,0.4,2.2c0,0,0.1,0,0.1,0c0.1,0,0.2,0,0.2,0.1
		c0.2,0.4,0.3,0.9,0.2,1.4c0,0.5-0.4,1.3-0.8,1.3c0,0-0.1,0-0.1,0c-0.1,0.4-0.2,0.8-0.4,1.2c-0.6,0.4-1.1,0.8-1.5,1.4"/>
			</xml>`,
			system: true,
			modified: false,
			deleted: false,
		}
	];
}
